import { Privileges } from 'src/app/privileges/privileges';

export const lcsRestrictedPrivileges = [
   Privileges.ManageCallRecordings_Enabled,
   Privileges.ManageRoles_View,
   Privileges.ManageRoles_Add,
   Privileges.ManageUsersAndPrivileges_Add,
   Privileges.ManageUsersAndPrivileges_View,
];
